import React from "react";
import { Switch, Route, useLocation } from "react-router-dom";
//import { CSSTransition, TransitionGroup } from "react-transition-group";
import PrivateRoute from "@/routes/PrivateRoute";

// pagina de acesso livre
import {
	Home,
	Regulation,
	Contact,
	About,
	SignIn,
	Confirmation,
	RegisterStore,
	RecoverPassword,
	ResetPassword,
	UpdateSigin,
	UpdateSiginConfirmation,
	UpdateSiginConfirmationPDV,
	NoMatch,
} from "@/pages/common";
import {
	PriviteHome,
	QrCode,
	Stores,
	Cupons,
	NotificationConsumer,
	Profile,
} from "@/pages/consumer";
import { PDVHome, ScanQrCode, PDVCupons, PDVProfile } from "@/pages/merchant";

const Routes = () => {
	let location = useLocation();

	return (			
		<Switch location={location}>
			<PrivateRoute path={`${process.env.PUBLIC_URL}/home/merchant`} component={PDVHome} />
			<PrivateRoute path={`${process.env.PUBLIC_URL}/scan-qrcode`} component={ScanQrCode} />
			<PrivateRoute path={`${process.env.PUBLIC_URL}/pdv-cupons`} component={PDVCupons} />
			<PrivateRoute path={`${process.env.PUBLIC_URL}/pdv-profile`} component={PDVProfile} />

			<PrivateRoute path={`${process.env.PUBLIC_URL}/profile`} component={Profile} />
			<PrivateRoute
				path={`${process.env.PUBLIC_URL}/notificacoes`}
				component={NotificationConsumer}
			/>
			<PrivateRoute path={`${process.env.PUBLIC_URL}/cupons`} component={Cupons} />
			<PrivateRoute path={`${process.env.PUBLIC_URL}/stores`} component={Stores} />
			<PrivateRoute path={`${process.env.PUBLIC_URL}/qrcode`} component={QrCode} />
			<PrivateRoute
				path={`${process.env.PUBLIC_URL}/home/consumer`}
				component={PriviteHome}
			/>

			<Route path={`${process.env.PUBLIC_URL}/confirmacao-de-dados/lojista/:id`} exact>
				<UpdateSiginConfirmationPDV />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/confirmacao-de-dados/:id`} exact>
				<UpdateSiginConfirmation />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/update-sigin/:type`}>
				<UpdateSigin />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/redefinicao-de-senha/:type`}>
				<ResetPassword />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/recuperar-senha/:type`}>
				<RecoverPassword />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/cadastro-lojista`}>
				<RegisterStore />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/cadastro-sucesso/:type`}>
				<Confirmation />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/login/:type`}>
				<SignIn />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/sobre`}>
				<About />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/contato`}>
				<Contact />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/regulamento`}>
				<Regulation />
			</Route>

			<Route path={`${process.env.PUBLIC_URL}/`} exact>
				<Home />
			</Route>
			<Route path={`${process.env.PUBLIC_URL}*`} component={NoMatch} />
		</Switch>
	);
};

export default Routes;
